import React from 'react';
import { useLanguage } from './Header';
import { useTranslation } from '../utils/translations';

const About = () => {
  const { language } = useLanguage();
  const t = useTranslation(language);
  const stats = [
    { number: "10K+", label: "Farmers Helped" },
    { number: "95%", label: "Accuracy Rate" },
    { number: "30%", label: "Yield Increase" },
    { number: "24/7", label: "AI Support" }
  ];

  return (
    <section id="disease" className="py-12 bg-gradient-to-br from-green-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('diseaseDetection')}</h2>
        
        <div className="grid lg:grid-cols-2 gap-8">
          <div className="card">
            <h3 className="text-lg font-semibold mb-4">{t('uploadLeafImage')}</h3>
            <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-dark-azure transition-colors">
              <div className="text-4xl mb-4">📷</div>
              <p className="text-gray-600 mb-4">{t('clickToUpload')}</p>
              <p className="text-sm text-gray-500">{t('fileFormat')}</p>
              <button className="btn-primary mt-4">{t('chooseImage')}</button>
            </div>
            
            <div className="mt-6">
              <h4 className="font-semibold mb-2">{t('quickTips')}</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>{t('takeClearPhotos')}</li>
                <li>{t('focusOnAffected')}</li>
                <li>{t('avoidBlurry')}</li>
              </ul>
            </div>
          </div>
          
          <div className="card">
            <h3 className="text-lg font-semibold mb-4">{t('analysisResult')}</h3>
            
            <div className="space-y-4">
              <div className="p-4 bg-red-50 border border-red-200 rounded-xl">
                <div className="flex items-center mb-2">
                  <div className="text-2xl mr-3">⚠️</div>
                  <h4 className="font-semibold text-red-900">{t('diseaseDetected')}</h4>
                </div>
                <p className="text-red-700 font-medium">{t('tomatoLateBlight')}</p>
                <p className="text-sm text-red-600">{t('confidenceLevel')}: 89%</p>
              </div>
              
              <div className="p-4 bg-blue-50 rounded-xl">
                <h4 className="font-semibold text-blue-900 mb-2">{t('treatmentRecommendations')}</h4>
                <ul className="text-sm text-blue-700 space-y-1">
                  <li>{t('applyFungicide')}</li>
                  <li>{t('removeLeaves')}</li>
                  <li>{t('improveAirflow')}</li>
                  <li>{t('reduceWatering')}</li>
                </ul>
              </div>
              
              <div className="p-4 bg-yellow-50 rounded-xl">
                <h4 className="font-semibold text-yellow-900 mb-2">{t('preventionTips')}</h4>
                <ul className="text-sm text-yellow-700 space-y-1">
                  <li>{t('waterAtSoil')}</li>
                  <li>{t('properSpacing')}</li>
                  <li>{t('monitorHumidity')}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;